import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment} from 'react';
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import { useMessage } from '../../context/message-context';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { Card, Table, TableBody, TableCell,Hidden, TableContainer, TableHead, Typography, TableRow, Button, Box } from "@mui/material";
import Grid from '@mui/material/Grid';
import ResponsiveDialog from '../shared/components/ResponsiveDialog';
import ProjektstundenGenehmigen from '../ProjektstundenGenehmigen';
import ProjektstundenArchiv from '../ProjektstundenArchiv';
import Projektstundenwoche from '../Projektstundenwoche';
import ProjektstundenAuswertung from '../ProjektstundenAuswertung';
import { Routes, Route} from "react-router-dom";
import ListAltIcon from '@mui/icons-material/ListAlt'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
function Projektstundenverteilung(props) {
  const { t } = useTranslation();
    // Standardvariablen
    const {client, accessToken, admin, userid, updateTitle} = props;
    const {showErrorMessage} = useMessage();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    //Arbeitsvariablen
    const [auswahl,setAuswahl]=useState([]);
    const [accept,setAccept]=useState("");
    const [accept_vorg,setAccept_vorg]=useState("");
    const [accept_highlight,setAccept_highlight]=useState("");
    const [,setAccept_vorg_highlight]=useState("");
    const [gesperrt,setGesperrt]=useState("");
    const [zukunft,setZukunft]=useState("");
    const [anlage,setAnlage]=useState("");
    const [auswertung,setAuswertung]=useState("");
    const [wochen,setWochen]=useState([]);
    const [woche,setWoche]=useState(0);
    const [user,setUser]=useState("");
    const [genehmigen,setGenehmigen]=useState([]);
    const [open,setOpen]=useState("");
    const [vorgesetzter,setVorgesetzter]=useState([]);
    const [openVorg,setOpenVorg]=useState(0);
    const [reload,setReload]=useState()
    const [fehler,setFehler]=useState("")
    //Funktionen
    useEffect(() => {
        setIsLoading(true);
        const payload={
            "mandant": client,
            "program": (admin==="J")?"PPROJ3":"PPROJN",
            "statement": (admin==="J")?"UEBERSICHT_VERT":"UEBERSICHT",  
            "admin":admin,
            "userid":userid,
        }
        const headers={
            "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers, postUebersicht);
        //eslint-disable-next-line
    }, [reload]);
    useEffect(() => {
        if (fehler&&fehler!==""){
            showErrorMessage(fehler)
            setFehler("")
        }
        //eslint-disable-next-line
    }, [fehler]);
    const postUebersicht=(response)=>{
        setIsLoading(false);
        if (response.status === 200) {
            setAuswahl(response.data.auswahl);
            setAccept(response.data.accept);
            setAccept_vorg(response.data.accept_vorg);
            setAccept_highlight(response.data.accept_highlight);
            setAccept_vorg_highlight(response.data.accept_vorg_highlight);
            setGesperrt(response.data.gesperrt);
            setZukunft(response.data.zukunft);
            setAnlage(response.data.anlage);
            setAuswertung(response.data.auswertung);
            setWochen(response.data.wochen);
            setWoche(0);
            console.log(response.data.fehler)
            if (response.data.fehler){
                setFehler(response.data.fehler)
            }
            setUser(response.data.user);
            setGenehmigen(response.data.genehmigen);
            setVorgesetzter(response.data.vorgesetzter);
            if (admin==="J") updateTitle("Projektstundenverteilung - Administrator ("+response.data.bearb_name+")")
        } else {
            if (response) {
                showErrorMessage(response.data.message);
            } else {
                showErrorMessage(t("Keine Internetverbindung"));
            }
        }
    }
    function pReload(){
        setIsLoading(true);
        const payload={
            "mandant": client,
            "program": (admin==="J")?"PPROJ3":"PPROJN",
            "statement": (admin==="J")?"UEBERSICHT_VERT":"UEBERSICHT",  
            "admin":admin,
            "userid":userid,
        }
        const headers={
            "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers, postUebersicht);
    }
    function Aktion(aktion,value){
        if (aktion==="accept"){
            setOpen("J")
        }
        if (aktion==="accept_vorg"){
            setOpenVorg(1)
        }
        if (aktion==="archiv"){
            if (admin==="J"){navigate('/PPROJ3/PPROJN/archiv')}else{navigate('/PPROJN/archiv')}
        }
        if (aktion==="kw"){
            if (admin==="J") {navigate('/PPROJ3/PPROJN/'+value)} else {navigate('/PPROJN/'+value)}
        }
        if (aktion==="auswertung"){
            if (admin!=="J") {navigate('/PPROJN/auswertung')}
        }
        if (aktion==="zukunft"){
            setWoche(1)
        }
        if (aktion==="anlage"){
            setIsLoading(true);
            const payload={
                "mandant": client,
                "program": (admin==="J")?"PPROJ3":"PPROJN",
                "statement": "RUECKWIRKEND",  
                "admin":admin,
                "userid":userid,
            }
            const headers={
                "Authorization": "Bearer "+accessToken,
            }
            apiRequest('POST', 'daten', payload, headers, postUebersicht);
        }
    }
    function LadeProj(key){
        if (admin==="J"){navigate('/PPROJ3/PPROJN/genehmigen/'+key)}else{navigate('/PPROJN/genehmigen/'+key)}
        
    }
    function Reload(){
        setReload(!reload)
      }
    if (isLoading) {
        return <LoadingComponent />
    }
    function AuswahlWoche(key){
        setIsLoading(true);
        const payload={
            "mandant": client,
            "program": (admin==="J")?"PPROJ3":"PPROJN",
            "statement": "VORAUS",  
            "key": key,  
            "user": user,  
            "admin":admin,
            "userid":userid,
        }
        const headers={
            "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers, postUebersicht);
    }
    function LadeVorg(key){
        setOpenVorg(0);
        if (admin==="J"){navigate('/PPROJ3/PPROJN/vorg'+key)}else{navigate('/PPROJN/vorg'+key)}
    }
    function Anzeige(){
        return(
            <Box p={2}>
            <Card>
                <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                        <h4>{t("Projektadministration")}</h4>
                    </Grid>
                    {(accept==="J")&&
                    <Fragment>
                        {(accept_highlight!=="J")&&
                        <Grid item xs={12} sm={7} md={5} lg={3}>
                        <Button onClick={() => Aktion("accept")}>
                        <Grid
                          container
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={12}>
                            <CheckOutlinedIcon color="primary" style={{ fontSize: 80 }}/>
                          </Grid>
                          <Grid item xs={12}>
                          <Typography >{t("Stundenverteilung auf Projekten genehmigen")}</Typography>
                          </Grid>
                        </Grid>
                        </Button>
                      </Grid>
                    }
                    {accept_highlight==="J"&&
                    <Grid item xs={12} sm={7} md={5} lg={3}>
                        <Button onClick={() => Aktion("accept")}>
                        <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        >
                        <Grid item xs={12}>
                            <ReportOutlinedIcon color="primary" style={{ fontSize: 80 }}/>
                        </Grid>
                        <Grid item xs={12}>
                        <Typography >{t("Stundenverteilung auf Projekten genehmigen (!!neu!!)")}</Typography>
                        </Grid>
                        </Grid>
                        </Button>
                    </Grid>
                    }
                      </Fragment>
                    }
                        {(accept&&accept_vorg)&&
                        <Hidden mdDown>
                            <Grid item xs={2}>
                            </Grid>
                            </Hidden>
                        }
                    {(accept_vorg==="J")&&
                        <Grid item xs={12} sm={7} md={5} lg={3}>
                        <Button onClick={() => Aktion("accept_vorg")}>
                        <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        >
                        <Grid item xs={12}>
                            <PersonOutlinedIcon color="primary" style={{ fontSize: 80 }}/>
                        </Grid>
                        <Grid item xs={12}>
                        <Typography >{t("Projektstunden auf Mitarbeiter verteilen")}</Typography>
                        </Grid>
                        </Grid>
                        </Button>
                    </Grid>
                    }
                </Grid>
                </Box>
            </Card>
            </Box>
        )
    }
    function Eigene(){
        return(
            <Box p={2}>
            <Card>
                <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <h4>{t("Eigene Projektstundenverteilung")}</h4>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Button fullWidth variant="contained" color="primary" onClick={() => Aktion("archiv")}>{t("Archiv")}</Button>
                        </Grid>
                        </Grid>
                    </Grid>
                    {(auswahl&&auswahl.length>0)&&
                    <Grid item xs={12}>
                        <TableContainer>
                        <Table size="small">
                        <Hidden lgDown>
                            {AnzeigeDesktop()}
                        </Hidden>
                        <Hidden lgUp>
                            {AnzeigeMobil()}
                        </Hidden>
                        </Table>
                        </TableContainer>
                    </Grid>
                    }
                </Grid>
                </Box>
            </Card>
            </Box>
        )
    }
    function AnzeigeDesktop(){
        return(
          <Fragment>
            {auswahl.map((item,index)=>{
              return(
                <TableRow style={{cursor: 'pointer', border:`1px solid rgba(${"224"},${"224"},${"224"},1)`}} hover key={item.key} onClick={() => Aktion("kw",item.id+item.jahr+item.kw)}>
                  <TableCell><ListAltIcon color="primary"/></TableCell>
                  <TableCell>{"KW "+item.kw}</TableCell>
                  <TableCell>{item.zeitraum}</TableCell>
                  <TableCell>{item.status}</TableCell>
                </TableRow>
              )
            })}   
          </Fragment>
        )
      }
      
      function AnzeigeMobil(preitem){
        return(
            <Fragment>
              {auswahl.map((item,index)=>{
                return(
                  <TableRow style={{cursor: 'pointer', border:`1px solid rgba(${"224"},${"224"},${"224"},1)`}} hover key={item.key} onClick={() => Aktion("kw",item.id+item.jahr+item.kw)}>
                    <TableCell><ListAltIcon color="primary"/></TableCell>
                    <TableCell>KW{" "+item.kw}<br/>{item.zeitraum}<br/>{item.status}</TableCell>
                  </TableRow>
                )
              })}   
            </Fragment>
          )
      }
    function Zusatz(){
        return(
            <Box p={2}>
            <Card>
                <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <h4>{t("Zusatzfeatures")}</h4>
                    </Grid>
                    {(auswertung==="J"&&admin!=="J")&&
                        <Grid item xs={12} sm={6} md={4}>
                            <Button variant="contained" color="primary" onClick={() => Aktion("auswertung")}>{t("Auswertung von Projekten")}</Button>
                        </Grid>
                    }
                    {(zukunft==="J"&&gesperrt!=="J")&&
                        <Grid item xs={12} sm={6} md={4}>
                            <Button variant="contained" color="primary" onClick={() => Aktion("zukunft")}>{t("Kalenderwoche im Voraus anlegen")}</Button>
                        </Grid>
                    }
                    {(anlage==="J")&&
                        <Grid item xs={12} sm={6} md={4}>
                            <Button variant="contained" color="primary" onClick={() => Aktion("anlage")}>{t("Fehlende Kalenderwoche(n) rückwirkend anlegen")}</Button>
                        </Grid>
                    }
                </Grid>
                </Box>
            </Card>
            </Box>
        )
    }
    function AddWoche(){
        return(
        <ResponsiveDialog 
          title={t("Eine Kalenderwoche in der Zukunft anlegen")}
          open={woche===1} 
          setOpen={(o) => setWoche(o)}
        >
            <TableContainer>
            <Table>
                <TableBody>
                    {(wochen&&wochen.length>0)&&wochen.map((item,index)=>{
                        return(
                        <TableRow
                            style={{cursor: 'pointer'}}
                            onClick={() => AuswahlWoche(item.key) }
                            hover
                        >
                            <TableCell>
                                {item.bez}<br/>{item.zr}
                            </TableCell>
                        </TableRow>
                        )
                    })}
                    {(!wochen||wochen.length<=0)&&
                        <TableRow><TableCell>{t("Es kann keine Woche mehr für die Zukunft angelegt werden")}</TableCell></TableRow>
                    }
                </TableBody>
            </Table>
            </TableContainer>
        </ResponsiveDialog>
        )
    }
    function AuswahlGenehm(){
        return(
            <ResponsiveDialog 
                title={t("Stundenverteilung auf Projekten genehmigen")}
                open={open==="J"||(open==="2"&&genehmigen&&genehmigen.length>0)} 
                setOpen={(o) => {setOpen("")}}
            > 
                {(genehmigen&&genehmigen.length>0)&&genehmigen.map((item,index)=>{
                    return(
                    <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    {"Jahr "+item.jahr+" KW "+item.kw}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(item.projekt&&item.projekt.length>0)&&item.projekt.map((item2,index2)=>{
                                return (
                                    <TableRow 
                                        style={{cursor: 'pointer'}}
                                        onClick={() => {setOpen("2");LadeProj(item.zr+item2.key)}}
                                        hover
                                    >
                                        <TableCell>
                                            {item2.bez}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                    </TableContainer>
                    )
                })}     
                {(!genehmigen||genehmigen.length<=0)&&
                    <TableRow><TableCell>{t("Es liegen momentan keine Anträge vor")}</TableCell></TableRow>
                }
            </ResponsiveDialog>
            )
    }
    function VorgesetztenAnsicht(){
        return(
            <ResponsiveDialog 
                title={t("Auswahl Mitarbeiter")}
                open={openVorg===1} 
                setOpen={(o) => {setOpenVorg(0)}}
            > 
                <TableContainer>
                <Table>
                    {(vorgesetzter&&vorgesetzter.length>0)&&vorgesetzter.map((item,index)=>{
                        return(
                        
                            <TableBody>
                                <TableRow 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => LadeVorg(item.user+item.jahr+item.kw) }
                                    hover
                                >
                                    <TableCell>
                                        <Typography>
                                            {item.jahr+" KW: "+item.kw+" - "+item.name}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                    
                        )
                    })}     
                    {(!vorgesetzter||vorgesetzter.length<=0)&&
                        <TableRow><TableCell>{t("Es liegt momentan kein Mitarbeiter zur Auswahl vor")}</TableCell></TableRow>
                    }
                </Table>
                </TableContainer>
            </ResponsiveDialog>
            )
    }
    function Verteilung(){
        return(
            <Grid container justifyContent="center" spacing={2}>
            {AddWoche()}
            {AuswahlGenehm()}
            {VorgesetztenAnsicht()}
            <Grid item xs={12} md={8}>
                {(accept==="J"||accept_vorg==="J")&&Anzeige()}
            </Grid>
            <Grid item xs={12} md={8}>
                {(gesperrt!=="J")&&Eigene()}
            </Grid>
            <Grid item xs={12} md={8}>
                {(auswertung==="J"||anlage==="J"||(zukunft==="J"&&gesperrt!=="J"))&&Zusatz()}
            </Grid>
        </Grid>
        )
    }
    //Rueckgabe
    return(
        <Routes>
            <Route path="/archiv/*" element={<ProjektstundenArchiv updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} admin={admin} userid={userid}/>}/>  
            <Route path="/genehmigen/:antragid" element={<ProjektstundenGenehmigen updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} admin={admin} userid={userid} pReload={pReload}/>}/>  
            <Route path="/auswertung" element={<ProjektstundenAuswertung updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} admin={admin} userid={userid}/>}/> 
            <Route path="/:antragid" element={<Projektstundenwoche updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} admin={admin} userid={userid} Reload={Reload}/>}/>  
            <Route path="/" element={Verteilung()}/>
        </Routes>
    )
}
export default Projektstundenverteilung;
